var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.getLatestAndPreviousBreakMinutes.latest)+" ")]),(_vm.showPreviousBreaks)?_c('div',{class:[
      _vm.strikeThroughPreviousBreaks ? 'text-decoration-line-through' : '',
      'text-caption opacity-5' ]},[_vm._v(" "+_vm._s(_vm.getLatestAndPreviousBreakMinutes.previous)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }